export default "__VITE_ASSET__DFIRM10O__"